const CLOUD_FEATURE_ORDER = [
  'cloudDevices',
  'activeCloudDevices',
  'mobileProfiles',
  'profilesTransfer',
] as const;

export const isCloudPlan = (plan?: { type?: string } | null): boolean => (
  plan?.type === 'cloudDevice'
);

export const isMeaningfulFeature = (value: unknown): boolean => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value > 0;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return false;
    const asNumber = Number(trimmed);
    return Number.isNaN(asNumber) ? true : asNumber > 0;
  }
  return value != null;
};

export const getCloudPlanFeatures = (
  features: Record<string, unknown> = {},
): Array<[string, unknown]> => {
  const ordered = CLOUD_FEATURE_ORDER
    .filter((key) => key in features && isMeaningfulFeature(features[key]))
    .map((key) => [key, features[key]] as [string, unknown]);

  const known = new Set<string>(CLOUD_FEATURE_ORDER);
  const rest = Object.entries(features).filter(
    ([key, value]) => !known.has(key) && key !== 'mobileAppAccess' && isMeaningfulFeature(value),
  );

  return [...ordered, ...rest];
};
